import React, { useState, useEffect, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import QRCode from "react-qr-code"

import { httpOk, GET, POST } from 'helpers/api'
import { formatMoney, formatDate } from 'helpers/helpers'
import logo from "assets/images/logo.png";

function Template() {
	const { t } = useTranslation();

	const data = {
		"row_number": 1,
		"id": 2658951,
		"cheque_id": 2658951,
		"cheque_number": 1,
		"total_amount": "125000.00",
		"total_amount_service": "143750.00",
		"service_amount": "18750",
		"paid": "143750.00",
		"discount": "0.00",
		"surcharge": "10000.00",
		"service_percentage": "15",
		"people_number": 1,
		"order_type": 1,
		"order_type_delivery": null,
		"status": 10,
		"cheque_opened_at": "2025-05-27 15:52:56",
		"cheque_closed_at": "2025-05-27 15:52:58",
		"cheque_sync_at": "2025-05-27 15:52:56",
		"note": "Примечание",
		"fiscal_terminal_id": null,
		"fiscal_sequence": null,
		"fiscal_sign": null,
		"fiscal_qr_code": null,
		"fiscal_date": null,
		"cashier_first_name": "Dilshod",
		"waiter_first_name": "Dilshod",
		"courier_name": "Dilshod",
		"cashbox_name": "Ibrohim kassa",
		"pos_name": "POS 1",
		"pos_short_name": "POS1",
		"pos_phone": "998998132213",
		"pos_address": "Toshkent",
		"hall_name": "Asosiy zal",
		"table_name": "VIP 2",
		"integration_name": "Яндекс Еда",
		"external_id": "190332-1234568",
		"products": [
			{
				"id": 10788485,
				"product_id": 822,
				"quantity": "2",
				"sale_price": "50000.00",
				"total_price": "100000.00",
				"discount": "0",
				"status": 10,
				"created_at": "2025-05-27 15:52:56",
				"name": "Big Burger",
				"fiscal_code": "02009001006000000",
				"fiscal_package_code": null,
				"fiscal_unit_id": 1,
				"vat": 12
			},
			{
				"id": 10788488,
				"product_id": 51172,
				"quantity": "1",
				"sale_price": "30000.00",
				"total_price": "30000.00",
				"discount": "0",
				"status": 10,
				"created_at": "2025-05-27 15:52:56",
				"name": "Olivie salat",
				"fiscal_code": "10202001001000001",
				"fiscal_package_code": "1372862",
				"fiscal_unit_id": 1,
				"vat": 12
			}
		],
		"payments": [
			{
				"id": 2431815,
				"amount": "143750.00",
				"payment_type_name": "ОФД Наличка",
				"payment_type_category_id": 1,
			}
		],
		"fiscal_data": {
			"fiscal_terminal_id": "LG420230652808",
			"fiscal_sequence": "94",
			"fiscal_date": "20250531170130",
			"fiscal_sign": "952151270351",
			"fiscal_qr_code": "https://ofd.soliq.uz/check?t=LG420230652808&r=94&c=20250531170130&s=952151270351"
		},
	}

	const [chequeSettings, setChequeSettings] = useState({})
	const chequeElements = [
		{
			'name': "Показать логотип",
			'value': 'show_logo',
		},
		{
			'name': "Показать название торговой точки",
			'value': 'show_pos_name',
		},
		{
			'name': "Показать телефон торговой точки",
			'value': 'show_pos_phone',
		},
		{
			'name': "Показать адрес торговой точки",
			'value': 'show_pos_address',
		},
		{
			'name': "Показать имя кассира",
			'value': 'show_cashier_name',
		},
		{
			'name': "Показать имя официанта",
			'value': 'show_waiter_name',
		},
		{
			'name': "Показать название зала",
			'value': 'show_hall_name',
		},
		{
			'name': "Показать название стола",
			'value': 'show_table_name',
		},
		{
			'name': "Показать ID чека",
			'value': 'show_cheque_id',
		},
		{
			'name': "Показать кол-во гостей",
			'value': 'show_people_number',
		},
		{
			'name': "Показать тип заказа",
			'value': 'show_order_type',
		},
		{
			'name': "Показать время открытие чека",
			'value': 'show_cheque_opened_at',
		},
		{
			'name': "Показать время закрытие чека",
			'value': 'show_cheque_closed_at',
		},
		{
			'name': "Показать НДС",
			'value': 'show_vat',
		},
		{
			'name': "Показать ИКПУ",
			'value': 'show_fiscal_code',
		},
		{
			'name': "Показать номер чека",
			'value': 'show_cheque_number',
		},
		{
			'name': "Показать QR код для отзыва",
			'value': 'show_feedback_qr',
		},
		{
			'name': "Показать текст для пречека",
			'value': 'show_promo_text_pre_cheque',
		},
		{
			'name': "Показать текст для оплаченного чека",
			'value': 'show_promo_text_post_cheque',
		},
	]

	async function storeChequeTemplate() {
		var response = await POST('/cheques-template', {
			'cheque_settings': chequeSettings
		}, { loader: true, notification: true })

		if (httpOk(response)) return
	}

	function handleChangeCheckbox(key) {
		var chequeSettingsCopy = { ...chequeSettings }
		chequeSettingsCopy[key] = !chequeSettingsCopy[key]

		setChequeSettings(chequeSettingsCopy)
	}

	function calculateVat(dataCopy, i) {
		const product = dataCopy.products[i];
		const sale = Number(product.sale_price) * Number(product.quantity);
		const discount = Number(product.discount) || 0;
		const vatRate = Number(product.vat);

		const vat = (sale - discount) * vatRate / (100 + vatRate);
		return formatMoney(vat);
	}

	async function getPosChequeSetting() {
		const response = await GET('/pos-cheque-settings')
		if (httpOk(response)) setChequeSettings(response.data)
	}

	useEffect(() => {
		getPosChequeSetting()
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('cheque_template')}
				</h4>
				<button className="btn btn-primary"
					onClick={() => storeChequeTemplate()}>
					{t('save')}
				</button>
			</div>

			<div className="d-flex gap-3">
				<div className="card w-100">
					<div className="card-body">
						{chequeElements.map((item, index) => (
							<div key={index}>
								<div className="d-flex align-items-center mb-2">
									<input className="form-check-input" type="checkbox"
										checked={chequeSettings[item.value]}
										onChange={() => handleChangeCheckbox(item.value)}
									/>
									<h5>{item.name}</h5>
								</div>
							</div>
						))}

						<input type="text" className="form-control mb-3" name="promo_text_pre_cheque"
							placeholder="Показать текст для пречека"
							disabled={!chequeSettings.show_promo_text_pre_cheque}
							value={chequeSettings.promo_text_pre_cheque ?? ''}
							onChange={(e) => setChequeSettings({ ...chequeSettings, 'promo_text_pre_cheque': e.target.value })} />

						<input type="text" className="form-control" name="promo_text_post_cheque"
							placeholder="Показать текст для оплаченного чека"
							disabled={!chequeSettings.show_promo_text_post_cheque}
							value={chequeSettings.promo_text_post_cheque ?? ''}
							onChange={(e) => setChequeSettings({ ...chequeSettings, 'promo_text_post_cheque': e.target.value })} />
					</div>
				</div>

				<div className="card" style={{ 'minHeight': '830px', 'width': '500px' }}>
					<div className="card-body">
						<div className="d-flex justify-content-center mt-3 mb-1">
							<div className="d-flex flex-column gap-1">
								{chequeSettings.show_logo &&
									<div className="d-flex justify-content-center">
										<img src={logo} width={120} alt="logo" />
									</div>
								}
								{chequeSettings.show_pos_name && <h5 className="text-center fw-700">{data.pos_name}</h5>}
								{chequeSettings.show_pos_phone && <h6 className="text-center fw-600">{t('phone')}: {data.pos_phone}</h6>}
								{chequeSettings.show_pos_address && <h6 className="text-center fw-500">{t('address')}: {data.pos_address}</h6>}
							</div>
						</div>

						<div className="cheque-block-1 cheque-border-bottom mb-2">
							{chequeSettings.show_cashier_name &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('cashier')}</p>
									<p>{data.cashier_first_name}</p>
								</div>
							}
							{chequeSettings.show_waiter_name &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('waiter')}</p>
									<p>{data.waiter_first_name}</p>
								</div>
							}
							{chequeSettings.show_courier_name &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('courier')}</p>
									<p>{data.courier_name}</p>
								</div>
							}
							{chequeSettings.show_hall_name &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('hall')}</p>
									<p>{data.hall_name}</p>
								</div>
							}
							{chequeSettings.show_table_name &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('table')}</p>
									<p>{data.table_name}</p>
								</div>
							}
							{chequeSettings.show_cheque_id &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('cheque')} ID </p>
									<p>{data.cheque_id}</p>
								</div>
							}
							{chequeSettings.show_cheque_number &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('cheque')} № </p>
									<p>{data.cheque_number}</p>
								</div>
							}
							{chequeSettings.show_people_number &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('guests')}</p>
									<p>{data.people_number}</p>
								</div>
							}
							{chequeSettings.show_tin &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('tin')}</p>
									<p>{data.tin}</p>
								</div>
							}
							{chequeSettings.show_order_type &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('order_type')} </p>
									{data.order_type === 1 &&
										<p>{t('hall')}</p>
									}
									{data.order_type === 2 &&
										<p>{t('takeaway')}</p>
									}
									{data.order_type === 3 &&
										<p>{t('delivery')}</p>
									}
								</div>
							}
							{chequeSettings.show_cheque_opened_at &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('open_date')}</p>
									<p>{formatDate(data.cheque_opened_at, 'dd.MM.yy HH:mm')}</p>
								</div>
							}
							{chequeSettings.show_cheque_closed_at &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('close_date')}</p>
									<p>{formatDate(data.cheque_closed_at, 'dd.MM.yy HH:mm')}</p>
								</div>
							}
						</div>

						<div className="cheque-block-2 cheque-border-bottom">
							<table className="custom-cheque-table w-100 fz-14">
								<thead>
									<tr>
										<th className="w-50"># {t('product')}</th>
										<th className="text-nowrap">{t('quantity')}</th>
										<th className="text-end">{t('price')}</th>
									</tr>
								</thead>
								<tbody>
									{data?.products?.map((item, index) => (
										<Fragment key={index}>
											<>
												<tr key={index}>
													<td><b>{index + 1}. {item.name}</b></td>
													<td className="text-center text-nowrap" style={{ 'verticalAlign': 'top' }}>
														<b>{formatMoney(item.quantity)}x{formatMoney(item.sale_price)}</b>
													</td>
													<td className="text-end text-nowrap" style={{ 'verticalAlign': 'top' }}>
														<b>{formatMoney(item.quantity * item.sale_price)}</b>
													</td>
												</tr>
												{Number(item.discount) > 0 &&
													<tr>
														<td className="ps-3">{t('discount')}</td>
														<td></td>
														<td className="text-end">{formatMoney(item.discount)}</td>
													</tr>
												}
												{(chequeSettings.show_vat && Number(item.vat) > 0) &&
													<tr>
														<td className="ps-3">{t('vat')} {formatMoney(item.vat)}%</td>
														<td></td>
														<td className="text-end">{calculateVat(data, index)}</td>
													</tr>
												}
												{(chequeSettings.show_fiscal_code && item.fiscal_code) &&
													<tr>
														<td className="ps-3">{t('mxik')}</td>
														<td></td>
														<td className="text-end">{item.fiscal_code}</td>
													</tr>
												}
											</>
										</Fragment>
									))}
								</tbody>
							</table>
						</div>

						<div className="cheque-block-3 cheque-border-bottom mb-2">
							<div className="d-flex justify-content-between">
								<p className="fw-600">{t('amount')}</p>
								<p>{formatMoney(data.total_amount)}</p>
							</div>
							{data.order_type === 1 &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('service')} {data.service_percentage ? data.service_percentage : 0}%</p>
									<p className="text-success">{formatMoney(data.service_amount)}</p>
								</div>
							}
							{!!data.delivery_price &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('delivery')} [km] {data.delivery_distance}</p>
									<p className="text-success">{formatMoney(data.delivery_price)}</p>
								</div>
							}
							{Number(data.discount) > 0 &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('discount')}</p>
									<p className="text-danger">{formatMoney(data.discount)}</p>
								</div>
							}
							{Number(data.surcharge) > 0 &&
								<div className="d-flex justify-content-between">
									<p className="fw-600">{t('surcharge')}</p>
									<p className="text-danger">{formatMoney(data.surcharge)}</p>
								</div>
							}
							<div className="d-flex justify-content-between">
								<p className="fw-600 fz-18">{t('total_payable')}</p>
								<p className="fw-600 fz-18">{formatMoney(data.total_amount_service)}</p>
							</div>
							<div className="d-flex justify-content-between">
								<p className="fw-600">{t('paid')}</p>
								<p className="fw-600">{formatMoney(data.paid)}</p>
							</div>
							{data?.payments?.map((item, index) => (
								<div className="d-flex justify-content-between" key={index}>
									{Number(item.amount) !== 0 ?
										<>
											<p>{item.payment_type_name}</p>
											<p>{formatMoney(item.amount)}</p>
										</>
										:
										<>
											<p>{item.payment_purpose_name}</p>
											<p>{formatMoney(item.amount)}</p>
										</>
									}
								</div>
							))}
							{Number(data.entity_debtor_amount) > 0 &&
								<div className="d-flex justify-content-between">
									<p>{t('debtor')}</p>
									<p>{data.entity_name}</p>
								</div>
							}
							{data.entity_debtor_amount > 0 &&
								<div className="d-flex justify-content-between">
									<p>{t('amount_of_debt')}</p>
									<p>{formatMoney(data.entity_debtor_amount)}</p>
								</div>
							}
							{(data.client_id && data.client_name) &&
								<div className="d-flex justify-content-between">
									<p>{t('client')}</p>
									{data.client_name && <p>{data.client_name}</p>}
								</div>
							}
							{Number(data.loyalty) > 0 &&
								<div className="d-flex justify-content-between">
									<p>{t('loyalty')}</p>
									<p>{formatMoney(data.loyalty)}</p>
								</div>
							}
							{(data.client_id && data.client_phone) &&
								<div className="d-flex justify-content-between">
									<p>{t('phone')}</p>
									{data.client_phone && <p>{data.client_phone}</p>}
								</div>
							}
							{(data.client_id && data.client_phone2) &&
								<div className="d-flex justify-content-between">
									<p>{t('phone')}2</p>
									{data.client_phone2 && <p>{data.client_phone2}</p>}
								</div>
							}
							{data.navigate &&
								<div className="d-flex justify-content-between">
									<p>{t('navigate')}</p>
									{data.navigate && <p className="text-end">{data.navigate}</p>}
								</div>
							}
							{chequeSettings.note &&
								<div className="d-flex justify-content-between">
									<p>{t('note')}</p>
									<p className="text-end">{data.note}</p>
								</div>
							}
							{(data.address_id && data.client_address) &&
								<div className="d-flex justify-content-between">
									<p>{t('address')}</p>
									{data.client_address && <p className="text-end">{data.client_address}</p>}
								</div>
							}

							<div className="d-flex justify-content-between">
								<p>SERVICE</p>
								<p>{data.integration_name}</p>
							</div>
							<div className="d-flex justify-content-between">
								<p>SERVICE ID</p>
								<p>{data.external_id}</p>
							</div>

							{/* FISCAL INFO */}
							{data?.fiscal_data?.fiscal_terminal_id &&
								<div className="d-flex justify-content-between">
									<p>{t('terminal')}</p>
									<p>{data?.fiscal_data?.fiscal_terminal_id}</p>
								</div>
							}
							{data?.fiscal_data?.fiscal_sign &&
								<div className="d-flex justify-content-between">
									<p>{t('fiscal_sign')}</p>
									<p>{data?.fiscal_data?.fiscal_sign}</p>
								</div>
							}
							{data?.fiscal_data?.fiscal_sign &&
								<div className="d-flex justify-content-center">
									<QRCode value={data?.fiscal_data?.fiscal_qr_code} size={140} />
								</div>
							}
							{/* FISCAL INFO */}

							{chequeSettings.show_feedback_qr &&
								<div className="d-flex justify-content-center pt-2">
									<div className="d-flex justify-content-center">
										<QRCode size={100}
											value={`1`} />
									</div>
								</div>
							}

							{chequeSettings.show_cheque_number &&
								<>
									<div className="text-center pt-2">
										<b className="fz18">{t('order_number')}</b>
									</div>

									<div className="text-center">
										<b style={{ 'fontSize': '55px' }}>{data?.cheque_number}</b>
									</div>
								</>
							}

							{chequeSettings.show_promo_text &&
								<div className="text-center">
									<p>Чаевые для офицанта всегда прилогаются но это исключительно на ваше усмотрение!</p>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Template